module.exports = __webpack_public_path__ + "static/media/americanExpress.e5bf0c8d.svg";